// extracted by mini-css-extract-plugin
export var animationContainer = "_oa-0";
export var footer = "_oa-1";
export var gray = "_oa-2";
export var lineItem = "_oa-3";
export var lineItemImage = "_oa-4";
export var lineItemInfo = "_oa-5";
export var lineItemText = "_oa-6";
export var lineItems = "_oa-7";
export var modalContent = "_oa-8";
export var options = "_oa-9";
export var orderName = "_oa-a";
export var refundAmount = "_oa-b";